export default __webpack_public_path__ + "static/media/focus-icon.15a1e775.svg";